/**
 * Created by fers on 05.02.16.
 */
/*eslint no-console: 0*/

import PropTypes from 'prop-types';

import BasicEditor from './BasicEditor.react';
import EditorSaver from './EditorSaver';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import EventTracker from '../app/EventTracker';

import './FormFields.scss';
import { Mutation } from '../../common/types/types';

interface EditorProps {
    extraConfig?: unknown[];
    fatQuery: object;
    mutation: Mutation;
    onBeforeSubmit?: (...args: unknown[]) => unknown;
    onFailure?: (...args: unknown[]) => unknown;
    onSuccess?: (...args: unknown[]) => unknown;
}

export default class Editor extends BasicEditor<EditorProps> {
    static propTypes = {
        extraConfig: PropTypes.array,
        fatQuery: PropTypes.object.isRequired,
        mutation: PropTypes.object.isRequired,
		onBeforeSubmit: PropTypes.func,
		onFailure: PropTypes.func,
        onSuccess: PropTypes.func,
    };

    static defaultProps = {
        onBeforeSubmit: () => Promise.resolve()
    };

    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    submitForm(data) {
        console.log("Saving", data);

        let defaultValue = null;

		return this.props.onBeforeSubmit(data).then(() => {
			if (this.isCreate()) {
				defaultValue = this.props.metadata.defaultValues(this.props.parent ? this.props.parent : {});
			}

			EventTracker.trackEvent(EventTracker.EVENT_CLICKS, {
				event: this.props.metadata.entity() + '-' + (this.isCreate() ? 'create' : 'edit'),
				type: 'application'
			});

			let saver = new EditorSaver(this.props.metadata, this.props.mutation, this.props.fatQuery, this.props.extraConfig, this.isCreate() ? EditorSaver.CREATE : null);
			return saver.save(data, defaultValue, this.props.columns, this.props.onSuccess ? this.props.onSuccess : this.defaultOnSuccess, this.props.onFailure ? this.props.onFailure : this.defaultOnFailure);
		});
    }
}
